<template>
  <b-modal class="modal-lg" hide-footer id="ruleInfoModal" ref="rule-info-modal" :title="modal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary"  @hide="resetModal">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'trash']" size="1x" class="mr-2"/> {{ modal.modalData.title }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <template v-if="isLoading">

      </template>
      <template v-else>
        <div class="col-12 px-0">
          <h5>{{ t('valuesPresentForThisRule', 'valuesPresentForThisRule') }} <span v-if="modal.modalData.ruleException">( {{ t('used_exception_' + modal.modalData.ruleException, 'used_exception_' + modal.modalData.ruleException) }} )</span></h5>
        </div>
        <div v-if="modal.modalData.ruleInfo && modal.modalData.ruleType" class="col-12 px-0">
          <div v-for="info in modal.modalData.ruleInfo" class="col-12 px-0" :key="info.value_name">
            - {{ info.value_name }}
          </div>
        </div>
        <div v-else class="col-12 px-0">
          {{ t('ruleInfoNotAvailableText', 'ruleInfoNotAvailableText') }}
        </div>
      </template>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ruleInfoModal',
  inject: [
    'modal',
    'resetModal',
    'refreshResults'
  ],
  data () {
    return {
      ruleInfo: null,
      ruleType: null,
      isLoading: false
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo'])
  },
  methods:{
    
  },
  created() {
  },
  components: {
    
  }
}
</script>

<style scoped>

</style>
